import React from 'react'

import PinLeftIcon from '../../../../../../Assets/Images/icons/pinLeft'
import PinRightIcon from '../../../../../../Assets/Images/icons/pinRight'
import {
  StyledWrapper,
  StyledMobileWrapper,
  StyledDivider,
  StyledMobile,
  StyledHeader,
  StyledHeaderTop,
  StyledTimeText,
  StyledIconsWrapper,
  StyledHeaderText,
  StyledBodyTitle,
  StyledBodyInfo,
  StyledBodyText,
  StyledContinueButton,
  StyledTouchPad,
} from './styles'

const MobileView = ({ additionalInfo }) => (
  <StyledWrapper>
    <StyledMobileWrapper>
      <StyledDivider />
      <StyledMobile>
        <StyledHeader>
          <StyledHeaderTop>
            <StyledTimeText>9:41</StyledTimeText>
            <StyledIconsWrapper>
              <PinLeftIcon />
              <PinRightIcon />
            </StyledIconsWrapper>
          </StyledHeaderTop>
          <StyledHeaderText>Additional info</StyledHeaderText>
        </StyledHeader>
        <StyledBodyTitle>Additional Information</StyledBodyTitle>
        <StyledBodyInfo>
          Please, read the following information carefully:
        </StyledBodyInfo>
        <StyledBodyText>{additionalInfo}</StyledBodyText>
        <StyledContinueButton>Continue</StyledContinueButton>
      </StyledMobile>
      <StyledTouchPad />
    </StyledMobileWrapper>
  </StyledWrapper>
)

export default MobileView
